<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.UnitConverter.title') }}</span>
      <span class="fmt-spacer"/>
      <span v-for="t in i18nTypes" :key="t.key" :class="['uc-chip',{on:type===t.key}]" @click="switchType(t.key)">{{ t.label }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>

    <div class="uc-convert">
      <!-- 输入 -->
      <div class="uc-card">
        <input class="uc-input" v-model="value" :placeholder="$t('tool.UnitConverter.phValue')" @input="convert" spellcheck="false"/>
        <el-select v-model="fromUnit" size="small" @change="convert" style="width:100%;margin-top:10px;">
          <el-option v-for="u in units" :key="u.key" :label="u.label" :value="u.key"/>
        </el-select>
      </div>

      <!-- 交换 -->
      <button class="uc-swap" @click="swap" :title="$t('tool.UnitConverter.swapTitle')">⇄</button>

      <!-- 输出 -->
      <div class="uc-card uc-card-out">
        <div class="uc-result">{{ result !== null ? result : '—' }}</div>
        <el-select v-model="toUnit" size="small" @change="convert" style="width:100%;margin-top:10px;">
          <el-option v-for="u in units" :key="u.key" :label="u.label" :value="u.key"/>
        </el-select>
      </div>
    </div>

    <div class="fmt-status-bar" v-if="result !== null">
      <span class="fmt-ok">{{ value }} {{ fromLabel }} = {{ result }} {{ toLabel }}</span>
    </div>
    <div class="fmt-status-bar" v-else>
      <span class="fmt-hint">{{ $t('tool.UnitConverter.hint') }}</span>
    </div>
  </div>
</template>

<script>
var TYPE_UNIT_KEYS = {
  storage:{B:{toB:1},KB:{toB:1024},MB:{toB:1048576},GB:{toB:1073741824},TB:{toB:1099511627776}},
  length:{mm:{toBase:.001},cm:{toBase:.01},m:{toBase:1},km:{toBase:1000},in:{toBase:.0254},ft:{toBase:.3048},mi:{toBase:1609.344}},
  weight:{mg:{toBase:.001},g:{toBase:1},kg:{toBase:1000},t:{toBase:1e6},oz:{toBase:28.3495},lb:{toBase:453.592}},
  temp:{c:{},f:{},k:{}},
  time:{ms:{toS:.001},s:{toS:1},min:{toS:60},h:{toS:3600},d:{toS:86400},w:{toS:604800}}
}
var typeDefaults={storage:['MB','GB'],length:['m','km'],weight:['kg','g'],temp:['c','f'],time:['min','s']}

export default {
  name:'UnitConverterTool',props:{config:{type:Object,default:function(){return{}}}},
  data:function(){
    return {type:'storage',value:'',fromUnit:'MB',toUnit:'GB',result:null,
      types:[{key:'storage'},{key:'length'},{key:'weight'},{key:'temp'},{key:'time'}]}
  },
  computed:{
    i18nTypes:function(){var t=this;return this.types.map(function(x){return{key:x.key,label:t.$t('tool.UnitConverter.types.'+x.key)}})},
    units:function(){var raw=TYPE_UNIT_KEYS[this.type];if(!raw)return[];var t=this;var labels=t.$t('tool.UnitConverter.units.'+this.type);return Object.keys(raw).map(function(k){return{key:k,label:labels[k]||k,toB:raw[k].toB,toBase:raw[k].toBase,toS:raw[k].toS}})},
    fromLabel:function(){var u=this.units.find(function(x){return x.key===this.fromUnit},this);return u?u.label:''},
    toLabel:function(){var u=this.units.find(function(x){return x.key===this.toUnit},this);return u?u.label:''}
  },
  methods:{
    switchType:function(t){
      this.type=t;var d=typeDefaults[t]||['',''];this.fromUnit=d[0];this.toUnit=d[1];this.convert()
    },
    swap:function(){var t=this.fromUnit;this.fromUnit=this.toUnit;this.toUnit=t;this.convert()},
    convert:function(){
      var v=parseFloat(this.value);if(isNaN(v)){this.result=null;return}
      var us=this.units,fu=us.find(function(u){return u.key===this.fromUnit},this),tu=us.find(function(u){return u.key===this.toUnit},this)
      if(!fu||!tu){this.result=null;return}
      if(this.type==='temp'){
        var c;if(this.fromUnit==='c')c=v;else if(this.fromUnit==='f')c=(v-32)*5/9;else if(this.fromUnit==='k')c=v-273.15
        if(this.toUnit==='c')this.result=c.toFixed(2);else if(this.toUnit==='f')this.result=((c*9/5)+32).toFixed(2);else if(this.toUnit==='k')this.result=(c+273.15).toFixed(2)
      }else{
        var bk=this.type==='storage'?'toB':this.type==='time'?'toS':'toBase'
        this.result=+(v*fu[bk]/tu[bk]).toFixed(6)
      }
    },
    clearAll:function(){this.value='';this.result=null},
    doAction:function(a){if(a==='clear')this.clearAll()}
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:14px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36;white-space:nowrap}
.fmt-spacer{flex:1}

.uc-chip{padding:5px 14px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;color:#909399;background:#f0f2f5;transition:.12s;border:1px solid transparent}
.uc-chip:hover{color:#4e7cff}
.uc-chip.on{background:#e8f0fe;color:#4e7cff;border-color:#4e7cff}

.uc-convert{display:flex;align-items:center;gap:16px}
.uc-card{flex:1;min-width:0;background:#fafbfc;border:1px solid #ebeef5;border-radius:14px;padding:20px;text-align:center;position:relative;overflow:hidden}
.uc-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px}
.uc-card:first-of-type::before{background:#4e7cff}
.uc-card-out::before{background:linear-gradient(90deg,#4e7cff,#67a870)}
.uc-card:focus-within{border-color:#4e7cff;box-shadow:0 0 0 3px rgba(78,124,255,.06)}
.uc-input{width:100%;box-sizing:border-box;border:none;outline:none;background:transparent;font-size:36px;font-family:'SF Mono',Menlo,Consolas,monospace;text-align:center;color:#1a1f36;font-weight:600}
.uc-input::placeholder{color:#d0d4dc;font-size:24px}
.uc-result{font-size:36px;font-family:'SF Mono',Menlo,Consolas,monospace;color:#4e7cff;font-weight:700;word-break:break-all;min-height:48px;display:flex;align-items:center;justify-content:center}
.uc-swap{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;border:1.5px solid #e1e5e9;background:#fff;color:#909399;font-size:18px;cursor:pointer;transition:.12s;flex-shrink:0}
.uc-swap:hover{border-color:#4e7cff;color:#4e7cff}

.fmt-status-bar{font-size:12px;text-align:center}
.fmt-ok{color:#67c23a}
.fmt-hint{color:#c0c4cc}

@media(max-width:640px){.uc-convert{flex-direction:column}.uc-swap{transform:rotate(90deg)}}
</style>
